export const INIT_YARA_DASHBOARD_FILTER_VALUES = {
  name: "",
  owner: "My Rulesets",
  status: "all",
  source: undefined
};

export const INIT_YARA_DASHBOARD_FILTER_MENU_DATA = {
  name: INIT_YARA_DASHBOARD_FILTER_VALUES.name,
  owner: {
    label: INIT_YARA_DASHBOARD_FILTER_VALUES.owner,
    value: INIT_YARA_DASHBOARD_FILTER_VALUES.owner
  },
  status: { label: "Status", value: INIT_YARA_DASHBOARD_FILTER_VALUES.status },
  source: { label: "Source", value: INIT_YARA_DASHBOARD_FILTER_VALUES.source }
};

export const DEFAULT_YARA_URL_PARAMS = `?owner=${encodeURIComponent(
  INIT_YARA_DASHBOARD_FILTER_VALUES.owner
).replace(/%20/g, "+")}`;
